const REACT_APP_API_URL = "https://app.goosegolfapp.com/admin/";

// const REACT_APP_API_URL = "http://localhost:4000/admin/";
export default REACT_APP_API_URL;
// export const REACT_APP_API_URL="https://meloapi.pankush.site/api/v1"
